import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import App from './App.vue'
import router from './router'
import store from './store'
import VueParticles from 'vue-particles'
import {Message} from 'element-ui'
// 在main.js中全局引入
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
 
Vue.use(VideoPlayer)
Vue.use(VueParticles)
// 引入echarts
const echarts = require('echarts')
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.prototype.$message = (options) => {
  // 设置默认消息持续时间为 2000 毫秒
  const duration = options.duration || 1500;
  const _msg = Message({
    ...options,
    duration: duration
  });
  setTimeout(() => {
    _msg.close();
  }, duration);
};

// Message.prototype.close = function() {
//   setTimeout(() => {
//     this.$el && this.$el.parentNode.removeChild(this.$el);  // 删除 message
//   }, 2000);
// };
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')



